/* ELF-FB20 lander, 13 Oct 2026 (dark-relight-1013). Stat cards under the operator band: the section keeps exactly half a card
   plus 40px below them, so the cards are never cut off and no empty band is left. No em or en dashes. */
(function () {
  function fit() {
    var s = document.querySelector('#no-dfb31 #capabilities');
    if (!s) return;
    var c = s.querySelector('[class*="translate-y-1/2"]');
    if (!c) return;
    var h = c.getBoundingClientRect().height;
    if (h > 0) s.style.paddingBottom = Math.round(h / 2 + 40) + 'px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit);
})();

/* Buy box (round 2, 13 Oct 2026): Bon wants the tube grade SLIDER back, so the tier cards are gone and the shared slider shows
   again with the ELF-FB20 pictures. Only the empty arrival card fix stays: the arrival card answers "show false" for every
   ELF-FB20 tier, which left an empty outlined bar under the button. ELF-FB20 only. */
(function () {
  function est() {
    var root = document.querySelector('[data-no-buy]');
    if (!root) return;
    var e = root.querySelector('.no-buy__est');
    if (!e) return;
    e.style.display = '';
    if (!(e.innerText || '').trim()) e.style.display = 'none';
  }
  function go() {
    var js = document.querySelector('[data-no-buy-data]'); var D = null;
    try { D = JSON.parse(js.textContent); } catch (x) {}
    if (!D || D.handle !== 'elf-fb20-thermal-fusion-night-vision-binocular') return;
    est();
    var n = 0, t = setInterval(function () { est(); if (++n > 16) clearInterval(t); }, 500);
    var root = document.querySelector('[data-no-buy]');
    if (root) root.addEventListener('click', function () { setTimeout(est, 1500); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
